/* eslint-disable import/prefer-default-export */
export const authUrl = 'https://core.copima.ma';
